/** Client-only validation that preview numbers fit the active game config. */
export function previewPickIsValidForGame(
  pick: { main: number[]; bonus: number[] },
  g: { mainCount: number; mainRange: number; bonusCount: number; bonusRange: number }
): boolean {
  if (pick.main.length !== g.mainCount || pick.bonus.length !== g.bonusCount) return false;
  if (new Set(pick.main).size !== g.mainCount) return false;
  if (g.bonusCount > 1 && new Set(pick.bonus).size !== g.bonusCount) return false;
  for (const n of pick.main) {
    if (!Number.isInteger(n) || n < 1 || n > g.mainRange) return false;
  }
  for (const n of pick.bonus) {
    if (!Number.isInteger(n) || n < 1 || n > g.bonusRange) return false;
  }
  return true;
}
